import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface RaceDaysDayItem {
    raceday_id?: number;
    season_id?: number;
    group_id?: number;
    circuit_id?: number;
    day_real?: string;
    day_planned?: string;
    season_name?: string;
    group_name?: string;
    circuit_name?: string;
    circuit_icon_small?: string;    
    circuit_icon_big?: string;
    circuit_country?: string;
    add_info1?: string;
    add_info2?: string;
    add_info3?: string;
    add_info4?: string;
}
    

/*
export interface RaceDaysAllDayItem {
    raceday_id?: number;
    day_real?: string;
    day_planned?: string;
    group_id?: number;
    group_name?: string;
    icon?: string;
    icon_color?: string;
}

export interface RaceDaysAllSeasonItem {
    season_id?: number;
    season_name?: string;
    days?: RaceDaysAllDayItem[];
}
*/

@Injectable()
export class RaceDaysTableService {
    private apiRaceDaysTableUrl = `${environment.apiBaseUrl}/api/raceDaysTable.php`;

    constructor(private http: HttpClient) {}

    getRaceDaysTable(): Observable<RaceDaysDayItem[]> {
        return this.http.get<RaceDaysDayItem[]>(this.apiRaceDaysTableUrl);
    }
}